// ─── Loyalty Engine API base URL ─────────────────────────────
export const LOYALTY_API_BASE =
    process.env.REACT_APP_LOYALTY_API_BASE_URL || "https://localhost:8001";

// ─── Per-section colour palette ──────────────────────────────
export const SECTION_COLORS = {
    tiers: { main: "#6C63FF", light: "#EEEDFF", gradient: "linear-gradient(135deg, #6C63FF 0%, #A855F7 100%)" },
    rewards: { main: "#6C63FF", light: "#EEEDFF", gradient: "linear-gradient(135deg, #6C63FF 0%, #A855F7 100%)" },
    bonus: { main: "#6C63FF", light: "#EEEDFF", gradient: "linear-gradient(135deg, #6C63FF 0%, #A855F7 100%)" },
    rules: { main: "#6C63FF", light: "#EEEDFF", gradient: "linear-gradient(135deg, #6C63FF 0%, #A855F7 100%)" },
    eventTypes: { main: "#6C63FF", light: "#EEEDFF", gradient: "linear-gradient(135deg, #6C63FF 0%, #A855F7 100%)" },
    search: { main: "#6C63FF", light: "#EEEDFF", gradient: "linear-gradient(135deg, #6C63FF 0%, #A855F7 100%)" },
};

// ─── Table pagination ────────────────────────────────────────
export const ROWS_PER_PAGE = 10;

// ─── Reward type display metadata ───────────────────────────
export const REWARD_TYPE_STYLES = {
    POINTS: { label: "Points", bgcolor: "#EDE9FE", color: "#7C3AED" },
    DISCOUNT: { label: "Remise", bgcolor: "#FEF3C7", color: "#D97706" },
    FREE_ITEM: { label: "Article offert", bgcolor: "#D1FAE5", color: "#059669" },
    CASHBACK: { label: "Cashback", bgcolor: "#DBEAFE", color: "#2563EB" },
    VOUCHER: { label: "Bon d'achat", bgcolor: "#FCE7F3", color: "#DB2777" },
};
export const REWARD_TYPES = Object.keys(REWARD_TYPE_STYLES);
